<!--
  --
  -- ユーザ制約項目 コンポーネント
  --
  -->
<template>
  <v-chip color="primary" small label>
    <slot/>
  </v-chip>
</template>

<script>
export default {
  name: 'CLimitedLabel'
}
</script>
